import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2B5A9E',
      light: '#A8C5E8',
      dark: '#1A3A6E',
    },
    secondary: {
      main: '#D4A574',
      light: '#E8D4B8',
    },
    background: {
      default: '#1A1A1A',
      dark: '#1A1A1A',
    },
    text: {
      primary: '#000000',
      secondary: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"Oswald", "Roboto", "Arial", sans-serif',
    h1: {
      fontFamily: '"Oswald", sans-serif',
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
    },
    h2: {
      fontFamily: '"Oswald", sans-serif',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.08em',
    },
    h3: {
      fontFamily: '"Oswald", sans-serif',
      fontWeight: 500,
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
    },
    body1: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 400,
      lineHeight: 1.8,
    },
    body2: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 300,
      lineHeight: 1.6,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

export default theme;
